import { BfzEventTeaserCard } from "components/page-components/Baufachzeitschriften/Termine"
import { Link } from "gatsby"
import React from "react"

export const LatestBfzEvents = ({ events }) => {
  return (
    <div data-nosnippet>
      <hr className="my-5" />
      <p className="title is-5 pl-3">
        Aktuelle Termine für unterirdische Infrastruktur
      </p>
      <div className="columns">
        {events.map((event, index) => (
          <div className="column is-4" key={`event-${index}`}>
            <BfzEventTeaserCard {...{ event }} />
          </div>
        ))}
      </div>
      <p className="has-text-centered link">
        <Link to={`/fachzeitschriften/umweltbau/termine`}>
          Alle wichtigen Termine für unterirdische Infrastruktur
        </Link>
      </p>
    </div>
  )
}
